import {
  gql,
  MutationHookOptions,
  QueryHookOptions,
  useMutation,
  useQuery,
} from '@apollo/client';
import {
  EntitySuppressionConfiguration,
  MutationCreateEntitySuppressionConfigurationArgs,
  MutationDeleteEntitySuppressionConfigurationArgs,
  MutationUpdateEntitySuppressionConfigurationArgs,
  QueryGetEntitySuppressionConfigurationArgs,
} from '../../../shared/generated/graphql';

export const GET_ENTITY_SUPPRESSION_CONFIGURATION = gql`
  query getEntitySuppressionConfiguration($tenant: String!) {
    getEntitySuppressionConfiguration(tenant: $tenant) {
      reason_for_suppression
      file_name
      file_content
      file_updated_at
      file_updated_by
      tenant
      fields_to_suppress
    }
  }
`;

export const useGetEntitySuppressionConfiguration = (
  options: QueryHookOptions<
    { getEntitySuppressionConfiguration: EntitySuppressionConfiguration },
    QueryGetEntitySuppressionConfigurationArgs
  >,
) =>
  useQuery<
    { getEntitySuppressionConfiguration: EntitySuppressionConfiguration },
    QueryGetEntitySuppressionConfigurationArgs
  >(GET_ENTITY_SUPPRESSION_CONFIGURATION, options);

export const CREATE_ENTITY_SUPPRESSION_CONFIGURATION = gql`
  mutation createEntitySuppressionConfiguration(
    $tenant: String!
    $create_config: CreateEntitySuppressionConfigurationInput
  ) {
    createEntitySuppressionConfiguration(
      tenant: $tenant
      create_config: $create_config
    ) {
      reason_for_suppression
      file_name
      file_content
      file_updated_at
      file_updated_by
      tenant
      fields_to_suppress
    }
  }
`;

export const useCreateEntitySuppressionConfiguration = (
  options: MutationHookOptions<
    { createEntitySuppressionConfiguration: EntitySuppressionConfiguration },
    MutationCreateEntitySuppressionConfigurationArgs
  >,
) =>
  useMutation<
    { createEntitySuppressionConfiguration: EntitySuppressionConfiguration },
    MutationCreateEntitySuppressionConfigurationArgs
  >(CREATE_ENTITY_SUPPRESSION_CONFIGURATION, options);

export const UPDATE_ENTITY_SUPPRESSION_CONFIGURATION = gql`
  mutation updateEntitySuppressionConfiguration(
    $tenant: String!
    $update_config: UpdateEntitySuppressionConfigurationInput
  ) {
    updateEntitySuppressionConfiguration(
      tenant: $tenant
      update_config: $update_config
    ) {
      reason_for_suppression
      file_name
      file_content
      file_updated_at
      file_updated_by
      tenant
      fields_to_suppress
    }
  }
`;

export const useUpdateEntitySuppressionConfiguration = (
  options: MutationHookOptions<
    { updateEntitySuppressionConfiguration: EntitySuppressionConfiguration },
    MutationUpdateEntitySuppressionConfigurationArgs
  >,
) =>
  useMutation<
    { updateEntitySuppressionConfiguration: EntitySuppressionConfiguration },
    MutationUpdateEntitySuppressionConfigurationArgs
  >(UPDATE_ENTITY_SUPPRESSION_CONFIGURATION, options);

export const DELETE_ENTITY_SUPPRESSION_CONFIGURATION = gql`
  mutation deleteEntitySuppressionConfiguration($tenant: String!) {
    deleteEntitySuppressionConfiguration(tenant: $tenant) {
      reason_for_suppression
      file_name
      file_content
      file_updated_at
      file_updated_by
      tenant
      fields_to_suppress
    }
  }
`;

export const useDeleteEntitySuppressionConfiguration = (
  options: MutationHookOptions<
    MutationDeleteEntitySuppressionConfigurationArgs,
    { tenant: string }
  >,
) =>
  useMutation<
    MutationDeleteEntitySuppressionConfigurationArgs,
    { tenant: string }
  >(DELETE_ENTITY_SUPPRESSION_CONFIGURATION, options);
